// extracted by mini-css-extract-plugin
export default {"tag":"Tag__tag--gTk70"};